module.exports = __webpack_public_path__ + "static/img/certificado-18001-2007.748f86b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion/certificado-18001-2007.jpg
// module id = XsLF
// module chunks = 0